var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "modal fade",
      attrs: { tabindex: "-1", role: "dialog" }
    },
    [
      _c(
        "div",
        { staticClass: "modal-dialog modal-xl", attrs: { role: "document" } },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("h5", [
                _vm._v(_vm._s(_vm.$t("survey.group.resultsModal.title")))
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.dismiss.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("×")]
              )
            ]),
            _vm._v(" "),
            _vm.group
              ? _c(
                  "div",
                  { staticClass: "modal-body" },
                  [
                    _c("VueGoodTable", {
                      attrs: {
                        columns: _vm.columnsConfig,
                        rows: _vm.results || [],
                        "pagination-options": _vm.paginationOptions,
                        "search-options": _vm.searchOptions,
                        isLoading: _vm.loading
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "emptystate",
                            fn: function() {
                              return [
                                !_vm.loading && _vm.loadingFailed
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "alert alert-danger",
                                        attrs: { role: "alert" }
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.$t("error.failedToLoad")
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  : _c("CenterOnParent", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t("generalNothingToShow")
                                          ) +
                                          "\n            "
                                      )
                                    ])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "table-row",
                            fn: function(props) {
                              return [
                                props.column.field === "actions"
                                  ? _c("div", { staticClass: "btn-group" }, [
                                      props.row.passed
                                        ? _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-sm btn-primary",
                                              attrs: {
                                                disabled: _vm.downloadingCertificate.includes(
                                                  props.row.resultId
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.downloadCertificate(
                                                    props.row
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _vm.downloadingCertificate.includes(
                                                props.row.resultId
                                              )
                                                ? _c("Spinner", {
                                                    attrs: { small: true }
                                                  })
                                                : _c("i", {
                                                    staticClass: "fa fa-award"
                                                  })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ])
                                  : _c("span", [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            props.formattedRow[
                                              props.column.field
                                            ]
                                          ) +
                                          "\n            "
                                      )
                                    ])
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        4130335942
                      )
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c("GroupResultsModalFooter", {
                  staticClass: "flex-grow-1 mr-4",
                  attrs: { results: _vm.results || [] }
                }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary",
                    attrs: { type: "button" },
                    on: { click: _vm.dismiss }
                  },
                  [_vm._v(_vm._s(_vm.$t("btnClose")))]
                )
              ],
              1
            )
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }